import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Install Core Agent on Linux (RHEL-based)";
const frontMatter = {
  "title": "Install Core Agent on Linux (RHEL-based)",
  "description": "Learn how to install Core Agent on RHEL-based Linux distributions."
};
import {Alert} from '@/components';
export function useTOC(props) {
  const _components = {
    code: "code",
    ..._provideComponents()
  };
  return [{
    value: "Supported environments",
    id: "supported-environments",
    depth: 2
  }, {
    value: "Dependencies",
    id: "dependencies",
    depth: 2
  }, {
    value: "Single line install",
    id: "single-line-install",
    depth: 2
  }, {
    value: "Mirrors for old CentOS versions",
    id: "mirrors-for-old-centos-versions",
    depth: 2
  }, {
    value: "Verify signatures",
    id: "verify-signatures",
    depth: 2
  }, {
    value: "Configure yum",
    id: "configure-yum",
    depth: 2
  }, {
    value: "Install",
    id: "install",
    depth: 2
  }, {
    value: <>{"Support for "}<_components.code>{"StartLimitIntervalSec"}</_components.code>{" in RHEL 7"}</>,
    id: "support-for-startlimitintervalsec-in-rhel-7",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    li: "li",
    mark: "mark",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Install Core Agent on Linux (RHEL-based)"}</_components.h1>{"\n"}<_components.p>{"In Chronosphere Telemetry Pipeline, you can use "}<_components.a href="/fleets">{"fleets"}</_components.a>{" to manage instances\nof Core Agent. Use this guide to install Core Agent on RHEL-based Linux distributions."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"Core Agent supports the following RHEL-based distributions and architectures:"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Distribution"}</_components.th><_components.th>{"Architectures"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td>{"Amazon Linux 2023"}</_components.td><_components.td>{"x86-64"}</_components.td></_components.tr><_components.tr><_components.td>{"Amazon Linux 2"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"CentOS 9 Stream"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"CentOS 8"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"CentOS 7"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"CentOS 6"}</_components.td><_components.td>{"x86-64"}</_components.td></_components.tr><_components.tr><_components.td>{"Rocky Linux 9"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Rocky Linux 8"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Alma Linux 8"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Red Hat Enterprise Linux 9"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Red Hat Enterprise Linux 8"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Red Hat Enterprise Linux 7"}</_components.td><_components.td>{"x86-64, arm64v8"}</_components.td></_components.tr><_components.tr><_components.td>{"Red Hat Enterprise Linux 6"}</_components.td><_components.td>{"x86-64"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"For RHEL-based installations, Core Agent has the following general dependencies:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li>{"libc"}</_components.li>{"\n"}<_components.li>{"libsasl"}</_components.li>{"\n"}<_components.li>{"libsystemd"}</_components.li>{"\n"}<_components.li>{"libyaml"}</_components.li>{"\n"}<_components.li>{"OpenSSL"}</_components.li>{"\n"}<_components.li>{"zlib"}</_components.li>{"\n"}</_components.ul>{"\n"}<_components.p>{"To retrieve a list of specific dependencies for your environment, run the following command:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"yum"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -q"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" deplist"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" PACKAGE"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace "}<_components.em><_components.code>{"PACKAGE"}</_components.code></_components.em>{" with the name of the Core Agent package."}</_components.p>{"\n"}<_components.h2 id={toc[2].id}>{toc[2].value}</_components.h2>{"\n"}<_components.p>{"Chronosphere provides a basic installation script that’s compatible with most Linux\nenvironment. This script always installs the most recent version of Core Agent."}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"curl"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -L"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" https://github.com/calyptia/lts-notifications/releases/latest/download/install-package.sh"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"|"}</_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" bash"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"However, for secure deployments, Chronosphere recommends following the full\ninstruction procedures for your Linux environment."}</_components.p>{"\n"}<_components.h2 id={toc[3].id}>{toc[3].value}</_components.h2>{"\n"}<_components.p>{"Because CentOS 6, CentOS 7, and CentOS 8 have reached end-of-life, their\ndefault yum repositories are unavailable. To install Core Agent on any of these\ndistributions, you must configure an appropriate mirror. For example:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"$"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" sed"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -i"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" 's/mirrorlist/#mirrorlist/g'"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" /etc/yum.repos.d/CentOS-"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#2B5581"
  }}>{"*"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#212121"
  }}>{" &&"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5BDE6",
    "--shiki-light": "#24292EFF"
  }}>{" \\"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  sed"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -i"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" 's|#baseurl=http://mirror.centos.org|baseurl=http://vault.centos.org|g'"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" /etc/yum.repos.d/CentOS-"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#2B5581"
  }}>{"*"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id={toc[4].id}>{toc[4].value}</_components.h2>{"\n"}<_components.p>{"Core Agent packages are signed with "}<_components.code>{"calyptia.key"}</_components.code>{". You can use rpm to verify these\nsignatures."}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"rpm"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --import"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia.key"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#212121"
  }}>{" &&"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5BDE6",
    "--shiki-light": "#24292EFF"
  }}>{" \\"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"rpm"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -K"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" PACKAGE"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace "}<_components.em><_components.code>{"PACKAGE"}</_components.code></_components.em>{" with the name of the Core Agent package."}</_components.p>{"\n"}<_components.h2 id={toc[5].id}>{toc[5].value}</_components.h2>{"\n"}<_components.p>{"Chronosphere provides the "}<_components.code>{"calyptia-fluent-bit"}</_components.code>{" package through a yum repository.\nTo add the repository reference to your environment, add a new file in\n"}<_components.code>{"/etc/yum.repos.d/"}</_components.code>{" with the following content:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{"["}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{"calyptia-fluent-bit"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"name"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Calyptia"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Fluent"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Bit"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"baseurl"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" https://calyptia-lts-release-standard.s3.amazonaws.com/linux/25.1.5/"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"DISTRO"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"-"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"VERSION"}</_components.span></_components.mark></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{"gpgcheck"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"1"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{"gpgkey"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"https://calyptia-lts-release-standard.s3.amazonaws.com/linux/25.1.5/calyptia.key"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{"repo_gpgcheck"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"1"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{"enabled"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"1"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace "}<_components.em><_components.code>{"DISTRO"}</_components.code></_components.em>{" with either "}<_components.code>{"amazonlinux"}</_components.code>{" or "}<_components.code>{"package-centos"}</_components.code>{", and replace\n"}<_components.em><_components.code>{"VERSION"}</_components.code></_components.em>{" with the relevant version number."}</_components.p>{"\n"}<Alert severity="info"><_components.p>{"As a security best practice, enable "}<_components.code>{"gpgcheck"}</_components.code>{" and "}<_components.code>{"repo_gpgcheck"}</_components.code>{". Chronosphere\nsigns all repository metadata and packages."}</_components.p></Alert>{"\n"}<_components.h2 id={toc[6].id}>{toc[6].value}</_components.h2>{"\n"}<_components.p>{"After you’ve configured your repository, follow these steps."}</_components.p>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p>{"Run the following command to install Core Agent:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"sudo"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" yum"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" install"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia-fluent-bit"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Run the following command to instruct systemd to enable the Core Agent service:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"sudo"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" service"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia-fluent-bit"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" start"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Perform a status check to confirm Core Agent is active. The status check\nshould return output similar to the following:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"●"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia-fluent-bit.service"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Calyptia"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Fluent"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" Bit"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"   Loaded:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" loaded"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" (/usr/lib/systemd/system/calyptia-fluent-bit.service"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{";"}</_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" enabled"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{";"}</_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" vendor"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" preset:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" disabled"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"   Active:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" active"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" (running) since Thu 2023-06-08 15:55:03 UTC"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{";"}</_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" 9s"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" ago"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"     Docs:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" https://docs.fluentbit.io/manual/"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" Main"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" PID:"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 16631"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" (calyptia-fluent)"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"   CGroup:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" /system.slice/calyptia-fluent-bit.service"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"           └─16631"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" /opt/calyptia-fluent-bit/bin/calyptia-fluent-bit"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -c"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" //etc/calyptia-fluent-bit/calyptia-fluent-bit.conf"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"The default configuration of Core Agent is to collect metrics of CPU usage\nand send those metrics to stdout. You can see this outgoing data in your\n"}<_components.code>{"/var/log/messages"}</_components.code>{" file."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ol>{"\n"}<_components.h2 id={toc[7].id}>{toc[7].value}</_components.h2>{"\n"}<_components.p>{"In Core Agent version 25.1.5 or later, the Core Agent systemd file doesn’t\ninclude the "}<_components.code>{"StartLimitIntervalSec"}</_components.code>{" configuration in RHEL 7 due to incompatibility\nwith systemd 219."}</_components.p>{"\n"}<_components.p>{"RHEL versions that use systemd 230 or later are unaffected by this change."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/fleets/agent/linux-rhel-install',
  {"filePath":"pages/fleets/agent/linux-rhel-install.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)